/**
 * F61 — the value, delayed until it has stopped changing for `delayMs`.
 *
 * Search boxes feed the debounced value (not the raw input) into their fetch
 * effect, so typing "padel" sends one request instead of five. Pair it with an
 * `AbortController` in the effect so a slow earlier response can't land last.
 */
import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
